import axios from 'axios';
import React, { useState } from 'react';
import {
  Alert,
  Button,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { AdminNav } from '../AdminNav';
import { apiUrl } from '../../config';
import {
  AppointmentHolidayImportRequest,
  AppointmentHolidayImportResultDto,
} from '../../interfaces/adminSettings';

const defaultHolidaySourceUrl = 'https://opencom.no/dataset/49cb0ec9-e139-4f79-bc5e-309c4faf8396/resource/f8f57a81-a22b-4c4a-b06d-2b25ee53732f/download/helligdagskalender.json';

function AdminSettings() {
  const [holidaySourceUrl, setHolidaySourceUrl] = useState(defaultHolidaySourceUrl);
  const [importing, setImporting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<AppointmentHolidayImportResultDto | null>(null);

  const handleImport = async () => {
    setImporting(true);
    setError(null);
    setResult(null);

    const payload: AppointmentHolidayImportRequest = {
      url: holidaySourceUrl.trim(),
    };

    try {
      const response = await axios.post<AppointmentHolidayImportResultDto>(
        `${apiUrl}/admin/settings/holidays/import`,
        payload,
      );
      setResult(response.data);
    } catch (err: any) {
      if (err?.response?.data) {
        setError(String(err.response.data));
      } else {
        setError('Kunne ikke importere helligdager.');
      }
    } finally {
      setImporting(false);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} md={2}>
        <AdminNav />
      </Grid>
      <Grid item xs={12} md={10} sx={{ p: 3 }}>
        <Typography variant="h5" color="text.secondary" gutterBottom>
          Innstillinger
        </Typography>

        <Paper sx={{ p: 3 }}>
          <Stack spacing={2}>
            <Typography variant="h6">Helligdager</Typography>
            <Typography variant="body2" color="text.secondary">
              Lim inn en HTTPS-lenke fra en godkjent kilde. JSON-formatet ma fortsatt inneholde feltene
              {' '}<strong>dato</strong>{' '}og{' '}<strong>navn</strong>.
            </Typography>

            <TextField
              fullWidth
              label="URL til helligdags-JSON"
              value={holidaySourceUrl}
              onChange={(event) => setHolidaySourceUrl(event.target.value)}
            />

            {error && <Alert severity="error">{error}</Alert>}

            {result && (
              <Alert severity="success">
                Import fullført. Nye: {result.importedCount}, oppdatert: {result.updatedCount}, uendret: {result.unchangedCount},
                siste dato: {result.latestDate}
              </Alert>
            )}

            <Stack direction="row" spacing={2} alignItems="center">
              <Button variant="contained" onClick={handleImport} disabled={importing}>
                {importing ? 'Importerer...' : 'Importer helligdager'}
              </Button>
              {result && (
                <Typography variant="body2" color="text.secondary">
                  Kilde: {result.sourceUrl}
                </Typography>
              )}
            </Stack>
          </Stack>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default AdminSettings;
